var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApikey1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.16602 6.50016V5.75016H2.41602V6.50016H3.16602ZM12.8327 6.50016H13.5827V5.75016H12.8327V6.50016ZM12.8327 14.1668V14.9168H13.5827V14.1668H12.8327ZM3.16602 14.1668H2.41602V14.9168H3.16602V14.1668ZM4.41602 6.50016V7.25016H5.91602V6.50016H4.41602ZM8.74935 9.3335V8.5835H7.24935V9.3335H8.74935ZM7.24935 11.3335V12.0835H8.74935V11.3335H7.24935ZM3.16602 7.25016H12.8327V5.75016H3.16602V7.25016ZM12.0827 6.50016V14.1668H13.5827V6.50016H12.0827ZM12.8327 13.4168H3.16602V14.9168H12.8327V13.4168ZM3.91602 14.1668V6.50016H2.41602V14.1668H3.91602ZM5.91602 6.50016V4.66683H4.41602V6.50016H5.91602ZM7.99935 2.5835C9.14994 2.5835 10.0827 3.51624 10.0827 4.66683H11.5827C11.5827 2.68781 9.97837 1.0835 7.99935 1.0835V2.5835ZM7.99935 1.0835C6.02033 1.0835 4.41602 2.68781 4.41602 4.66683H5.91602C5.91602 3.51624 6.84876 2.5835 7.99935 2.5835V1.0835ZM7.24935 9.3335V11.3335H8.74935V9.3335H7.24935Z",
    fill: "#263DFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApikey1);
export default __webpack_public_path__ + "static/media/apikey1.9e88e634424842a8008614c9b2e55f1f.svg";
export { ForwardRef as ReactComponent };